import memberProspectsApi from '../api/memberProspectsApi';
import memberProfileModel from '../models/memberProfile';
import memberProspects from '../models/memberProspects';
import { PROSPECTS, PLACE_ID_DEFAULT } from '../constants/constants';
import eventDetail from '../models/eventDetail';

class MemberProspectsService {
  getUserProfileViewProspects(params) {
    return memberProspectsApi.getUserProfileViewProspects(params).then(res => {
      //  console.log('Prospect res', res)
      try {
        if (res.success) {
          return {
            success: true,
            data: memberProfileModel.mappingObjectsCustomMemberSearch(res.data.items),
          };
        }
        console.log('ERROR: MemberPoSpecService/getUserProfileViewProspects:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/getUserProfileViewProspects:', e);
        throw new Error('failed');
      }
    });
  }
  deleteUserProfileViewProspects(params) {
    return memberProspectsApi.deleteUserProfileViewProspects(params).then(res => {
      try {
        if (res.success) {
          // console.log('memberProspectsService/deleteUserProfileViewProspects', res)
          //  @get res array Profiles[] has been delete
          // return res
        } else {
          //     console.log("ERROR: MemberPoSpecService/deleteUseProfileViewProSpec:", res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/deleteUserProfileViewProspects:', e);
        throw new Error('failed');
      }
    });
  }
  getUserUserMatchProspects(params) {
    const body = { ...params, IsFavourite: false };
    return memberProspectsApi.getUserUserMatchProspects(body).then(res => {
      try {
        if (res.success && res.data) {
          return {
            success: true,
            data: memberProspects.mappingProspectModal(res.data),
          };
        }
        console.log('ERROR: MemberPoSpecService/getUserUserMatchProspects:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/getUserUserMatchProspects:', e);
        throw new Error('failed');
      }
    });
  }
  deleteUserMatchProspects(params) {
    return memberProspectsApi.deleteUserMatchProspects(params).then(res => {
      try {
        if (res.success) {
          //  @get res array Profiles[] has been delete
          // return res
        } else {
          //     console.log("ERROR: MemberPoSpecService/deleteUserLikeOrMatchProspects:", res.message);
        }
        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/deleteUserMatchProspects:', e);
        throw new Error('failed');
      }
    });
  }
  getUserUserFavouriteProspects(params) {
    return memberProspectsApi.getUserUserFavouriteProspects(params).then(res => {
      try {
        if (res.success) {
          const resData = { success: true, data: [] };
          if (res.data) {
            if (res.data.items) {
              resData.data = memberProfileModel.mappingObjectsCustomMemberSearch(res.data.items);
            } else {
              resData.data = memberProspects.mappingProspectModal(res.data);
            }
          }
          return resData;
        }
        console.log('ERROR: MemberPoSpecService/getUserUserFavouriteProspects:', res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/getUserUserFavouriteProspects:', e);
        return { success: false, data: [] };
      }
    });
  }
  deleteUserFavouriteProspects(params) {
    return memberProspectsApi.deleteUserFavouriteProspects(params).then(res => {
      try {
        if (res.success) {
          //  @get res array Profiles[] has been delete
          return { success: true };
        }
        //     console.log("ERROR: MemberPoSpecService/deleteUserLikeOrMatchProspects:", res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/deleteUserFavouriteProspects:', e);
        throw new Error('failed');
      }
    });
  }

  deleteUserLikesProspect(params) {
    return memberProspectsApi.deleteUserLikesProspect(params).then(res => {
      try {
        if (res.success) {
          return { success: true };
        }
        //     console.log("ERROR: MemberPoSpecService/deleteUserLikeOrMatchProspects:", res.message);

        return res;
      } catch (e) {
        console.log('ERROR: memberProspectsService/deleteUserFavouriteProspects:', e);
        throw new Error('failed');
      }
    });
  }

  // getProspectsCount() {
  //   return memberProspectsApi.getProspectsCount().then(res => {
  //     // console.log(res)
  //     try {
  //       //console.log("Memberprospect count service", res.data)
  //       if (res.success) {
  //         //  @get res array Profiles[] has been delete
  //         return {success: true, data: memberProspects.mappingObjectCount(res.data)};
  //       } else {
  //         //     console.log("ERROR: MemberPoSpecService/deleteUserLikeOrMatchProspects:", res.message);
  //       }
  //       return res;
  //     } catch (e) {
  //       console.log("ERROR: memberProspectsService/deleteUserFavouriteProspects:", e);
  //       throw ("failed");
  //     }
  //   });
  // }

  getUserLikeStateCount(params) {
    // Default get count for Like tab
    const body = {
      ListType: params.listType ? params.listType : PROSPECTS.USERS_LIKES,
      Type: params.type ? params.type : PROSPECTS.TYPE_ON,
      IsFavourite: params.isFavourite ? params.isFavourite : false,
    };
    return memberProspectsApi.getUserLikeStateCount(body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: eventDetail.mappingEventPopularCounts(res.data.items, PLACE_ID_DEFAULT),
          };
        }
        console.log('ERROR: memberProspectsService/getUserLikeStateCount:', res.message);
        return { success: false, data: [] };
      } catch (e) {
        console.log('ERROR: memberProspectsService/getUserLikeStateCount:', e);
        throw new Error('failed');
      }
    });
  }

  getUserProfileViewStateCount(params) {
    // Default get count for Like tab
    const body = {
      Type: params.type ? params.type : PROSPECTS.TYPE_ON,
    };
    if (params.googleMapPlaceID) {
      body.GoogleMapPlaceID = params.googleMapPlaceID;
    }
    return memberProspectsApi.getUserProfileViewStateCount(body).then(res => {
      try {
        if (res.success) {
          return {
            success: true,
            data: eventDetail.mappingEventPopularCounts(res.data.items, PLACE_ID_DEFAULT),
          };
        }
        console.log('ERROR: memberProspectsService/getUserProfileViewStateCount:', res.message);
        return { success: false, data: [] };
      } catch (e) {
        console.log('ERROR: memberProspectsService/getUserProfileViewStateCount:', e);
        throw new Error('failed');
      }
    });
  }
}

export default new MemberProspectsService();
